import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import SectionTitle from "../sectionTitle";
import style from './style.module.scss';
import ButtonDemo from '../button';
import HeroTitle from '../heroTitle/index'

export function CTA() {
    const { t } = useTranslation();
    const [active, setActive] = useState(0)

    const testimonials = t('cta.testimonials', { returnObjects: true })

    return (
        <section className={`container section ${style['cta']}`}>
            <SectionTitle
                title={t('cta.title')}
                label={t('cta.label')}
            />

            <div className={style['cta__reviews']}>
                <div className={style['cta__authors']}>
                    {testimonials.map((item, i) => (
                        <div
                            key={i}
                            className={`${style['cta__author']} ${i === active ? style['cta__author--active'] : ''}`}
                            onClick={() => setActive(i)}
                        >
                            <div className={style['cta__author-avatar']}>
                                {item.initials}
                            </div>

                            <div className={style['cta__author-info']}>
                                <span className={style['cta__author-role']}>
                                    {item.role}
                                </span>

                                <span className={style['cta__author-company']}>
                                    {item.company}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                <div className={style['cta__divider']} />

                <div className={style['cta__content']}>
                    <div className={style['cta__stars']}>
                        {'★'.repeat(testimonials[active].stars)}
                    </div>

                    <p className={style['cta__text']}>
                        {testimonials[active].text}
                    </p>
                </div>
            </div>

            <div className={style['cta__bottom']}>
                <HeroTitle>
                    {t('cta.bottom.before')}
                    <span className="accent">
                        {t('cta.bottom.accent')}
                    </span>
                    {t('cta.bottom.after')}
                </HeroTitle>

                <p>{t('cta.bottom.description')}</p>

                <ButtonDemo
                    size='large'
                    directIcon
                >
                    {t('button.titleBook')}
                </ButtonDemo>
            </div>
        </section>
    )
}